const translations = {
  // ── Client Portal ──
  'client.portal.yourProject': 'あなたのプロジェクト',
  'client.portal.noProjectLinked': 'プロジェクト未連携',
  'client.portal.noProjectDesc': 'アカウントにプロジェクトがまだ連携されていません。Japan Homesが準備が整い次第、ここにプロジェクトを表示します。',
  'client.portal.latestFromJH': 'Japan Homesからの最新情報',
  'client.portal.latestFromJHDesc': '重要なプロジェクト情報、承認、日次ログ、支払い、ファイル、通知は、関連セクションに表示されます。',
  'client.portal.actionItems': '対応が必要な項目',
  'client.portal.actionItemsDesc': '指示、支払い承認、意思決定など、あなたの入力が必要な項目はここに表示されます。関連セクションで更新を確認してください。',
  'client.portal.instructions': '指示',
  'client.portal.instructionsDesc': '意思決定と承認',
  'client.portal.askQuestion': '質問する',
  'client.portal.askQuestionDesc': 'Japan Homesがお答えします',
  'client.portal.projectFiles': 'プロジェクトファイル',
  'client.portal.projectFilesDesc': '写真、書類、共有ファイルを確認',
  'client.portal.viewFiles': 'ファイルを見る',
  'client.portal.buildJourney': '建築の旅',
  'client.portal.noStagesYet': 'プロジェクトの段階が設定されると、ここに表示されます。',
  'client.portal.projectDetails': 'プロジェクト詳細',
  'client.portal.managedBy': '管理',
  'client.portal.projectCode': 'プロジェクトコード',
  'client.portal.estCompletion': '完了予定日',
  'client.portal.status': 'ステータス',
  'client.portal.type': '種別',
  'client.portal.projectProgress': 'プロジェクト進捗',
  'client.portal.checklistFinal': 'チェックリスト完了',
  'client.portal.scheduleFinal': 'スケジュール完了',
  'client.portal.completed': '完了',
  'client.portal.inProgress': '進行中',
  'client.portal.done': '完了',
  'client.portal.upcoming': '今後',
  'client.portal.delayed': '遅延',
  'client.portal.notStarted': '未開始',
  'client.portal.onHold': '保留',
  'client.portal.refreshing': '更新中...',
  'client.portal.complete': '{percent}% 完了',
  'client.portal.stagesCount': '{completed}/{total} 段階',
  'client.portal.currently': '現在: {stage} · {percent}% 完了',
  'client.portal.projectCompleted': 'プロジェクト完了',
  'client.portal.itemsCompleted': '{done}/{total} 項目完了',
  'client.portal.datesTBC': '未定',

  // ── Portal Tabs ──
  'client.tab.myProject': 'マイプロジェクト',
  'client.tab.schedule': 'スケジュール',
  'client.tab.checklist': 'チェックリスト',
  'client.tab.files': 'ファイル',
  'client.tab.notifications': '通知',
  'client.tab.projectProgramme': 'プロジェクト計画',
  'client.tab.programmeDesc': 'これはプロジェクトの計画スケジュールです。ご質問があればJapan Homesにお問い合わせください。',
  'client.tab.projectChecklist': 'プロジェクトチェックリスト',
  'client.tab.checklistDesc': 'プロジェクトの完了項目を確認・承認してください。',
  'client.tab.dailyLog': '日報',
  'client.tab.dailyLogDesc': 'Japan Homesが共有する現場写真と日々の進捗更新です。',
  'client.tab.changeOrders': '変更指示',

  // ── Client Change Orders ──
  'client.changeOrders.empty': '変更指示はまだありません。',
  'client.changeOrders.emptyDesc': 'Japan Homesは、スコープ、仕様、または価格の変更がある場合にここに変更指示を共有します。',
  'client.changeOrders.pageDesc': 'プロジェクトの変更指示、価格更新、承認を確認できます。',
  'client.changeOrders.tabDesc': 'Japan Homesから共有された変更指示と価格更新です。',
  'client.changeOrders.attachments': '添付ファイル',
  'client.changeOrders.approvalPending': '承認待ち',
  'client.changeOrders.approvalApproved': '承認済み',
  'client.changeOrders.approvalDeclined': '却下',
  'client.changeOrders.approvalNotRequired': '参考情報',
  'client.changeOrders.loadError': '変更指示の読み込みに失敗しました',

  // ── Client Daily Log ──
  'client.dailyLog.title': '日次ログ',
  'client.dailyLog.siteUpdates': '現場の日次更新',
  'client.dailyLog.siteUpdatesDesc': 'Japan Homesが共有した現場の進捗写真',
  'client.dailyLog.dailySiteUpdates': '日次現場更新',
  'client.dailyLog.dailySiteUpdatesDesc': 'これらの写真は、Japan Homesが選定・共有したもので、プロジェクトの進捗状況をお知らせします。',
  'client.dailyLog.noSiteUpdates': '現場更新はまだありません',
  'client.dailyLog.noSiteUpdatesDesc': 'Japan Homesは工事が進むにつれて、現場写真と日次進捗更新をここに共有します。',
  'client.dailyLog.noPhotos': '写真はまだありません。工事が始まると表示されます。',
  'client.dailyLog.photoUnavailable': '写真を表示できません',

  // ── Client Instructions ──
  'client.instructions.title': '指示',
  'client.instructions.instructionsDecisions': '指示と意思決定',
  'client.instructions.instructionsDesc': '承認が必要な注文変更、変更点、および意思決定',
  'client.instructions.pending': '対応待ち {count} 件',
  'client.instructions.noInstructions': '指示はまだありません',
  'client.instructions.noInstructionsDesc': 'Japan Homesは注文変更、変更点、重要な意思決定をここに共有します。',
  'client.instructions.reason': '理由:',
  'client.instructions.cost': '費用:',
  'client.instructions.schedule': 'スケジュール:',
  'client.instructions.yourResponse': 'あなたの回答',
  'client.instructions.approve': '承認',
  'client.instructions.decline': '却下',
  'client.instructions.confirmApproval': '承認を確定',
  'client.instructions.confirmDecline': '却下を確定',
  'client.instructions.approveChangeOrder': 'この変更指示を承認しますか?',
  'client.instructions.declineChangeOrder': 'この変更指示を却下しますか?',
  'client.instructions.optionalComment': '任意のコメント...',
  'client.instructions.cancel': 'キャンセル',
  'client.instructions.price': '料金：',
  'client.instructions.currentFinish': '現在：',
  'client.instructions.newFinish': '新しい：',

  // ── Client Payments ──
  'client.payments.title': '支払い',
  'client.payments.paymentSchedule': '支払いスケジュール',
  'client.payments.noPayments': '支払いスケジュールはまだありません',
  'client.payments.noPaymentsDesc': 'Japan Homesが近々、支払いスケジュールを設定します。',
  'client.payments.totalScheduled': '合計予定金額',
  'client.payments.paid': '支払済み',
  'client.payments.remaining': '残額',
  'client.payments.overdue': '期限超過',
  'client.payments.dueNow': '今回支払い',
  'client.payments.pending': '保留中',
  'client.payments.onTrack': '順調',
  'client.payments.amount': '金額',
  'client.payments.dueDate': '支払期限',
  'client.payments.confirmPayment': '支払いを確定',
  'client.payments.confirming': '確定中…',
  'client.payments.youConfirmed': '支払いを確定しました',
  'client.payments.confirmedByJH': 'Japan Homesが確認済み',
  'client.payments.failedToLoad': '支払いスケジュールの読み込みに失敗しました',
  'client.payments.gstNote': 'すべての金額は{currency}です。GST（消費税）を含む場合があります。支払いスケジュールについてご質問があれば、Japan Homesにお問い合わせください。',
  'client.payments.attention': 'ご注意',
  'client.payments.paymentOverdue': '期限超過 {count} 件',
  'client.payments.paymentDue': '今回支払い {count} 件',
  'client.payments.makePayment': 'お支払い後、「支払いを確定」をタップしてJapan Homesに通知してください。',

  // ── Client Questions ──
  'client.questions.title': '質問',
  'client.questions.yourQuestions': 'あなたの質問',
  'client.questions.askDesc': 'プロジェクトについてJapan Homesに何でも質問してください',
  'client.questions.ask': '質問する',
  'client.questions.client': 'クライアント',
  'client.questions.management': '管理',
  'client.questions.questionTitle': '質問のタイトル',
  'client.questions.questionPlaceholder': '例: キッチンのタイルの色',
  'client.questions.details': '詳細',
  'client.questions.detailsPlaceholder': '質問の詳細を記入してください...',
  'client.questions.attachments': '添付ファイル',
  'client.questions.addFiles': 'ファイルを追加 (JPG, PNG, PDF)',
  'client.questions.filesUploaded': 'ファイルは送信前にアップロードされます',
  'client.questions.noQuestions': '質問はまだありません',
  'client.questions.noQuestionsDesc': 'プロジェクトについてJapan Homesに質問すると、ここに返答が表示されます。',
  'client.questions.clientQuestion': 'クライアントの質問',
  'client.questions.answered': '回答済み',
  'client.questions.open': '未回答',
  'client.questions.awaitingResponse': 'Japan Homesの返答を待っています',
  'client.questions.japanHomesReply': 'Japan Homesの返答',
  'client.questions.send': '送信',

  // ── Client Updates ──
  'client.updates.title': '更新情報',
  'client.updates.latestSitePhotos': '最新現場写真',
  'client.updates.projectUpdates': 'プロジェクト更新',
  'client.updates.noUpdates': '更新情報はまだありません',
  'client.updates.noUpdatesDesc': 'Japan Homesはプロジェクトが進むにつれて、ここに更新情報を投稿します。',
  'client.updates.noPhotosYet': '写真はまだありません。工事が始まると表示されます。',
  'client.updates.commentOnUpdate': 'この更新にコメントする',
  'client.updates.hideComments': 'コメントを隠す',
  'client.updates.loadingComments': 'コメントを読み込み中...',
  'client.updates.comments': 'コメント {count} 件',
  'client.updates.reply': '返信',
  'client.updates.cancelReply': '返信をキャンセル',
  'client.updates.writeReply': '返信を書く...',
  'client.updates.leaveComment': 'Japan Homesへのコメントや質問を入力...',
  'client.updates.comment': 'コメント',
  'client.updates.japanHomes': 'Japan Homes',

  // ── Client Notifications ──
  'client.notifications.title': '通知',
  'client.notifications.all': 'すべて',
  'client.notifications.unread': '未読',
  'client.notifications.markAllRead': 'すべて既読にする',
  'client.notifications.noNotifications': '通知はありません',
  'client.notifications.noNotificationsDesc': 'Japan Homesが更新情報を投稿すると、ここに通知が表示されます',
  'client.notifications.allCaughtUp': '全て確認済み!',
  'client.notifications.noUnread': '未読の通知はありません',

  // ── Embed: Daily Log ──
  'embed.dailyLog.infoBanner': '日次現場更新',
  'embed.dailyLog.infoBannerDesc': 'これらの写真は、Japan Homesが選定・共有したもので、プロジェクトの進捗状況をお知らせします。',
  'embed.dailyLog.noSiteUpdates': '現場更新はまだありません',
  'embed.dailyLog.noSiteUpdatesDesc': 'Japan Homesは工事が進むにつれて、現場写真と日次進捗更新をここに共有します。',

  // ── Embed: Instructions ──
  'embed.instructions.noInstructions': '指示はまだありません',
  'embed.instructions.noInstructionsDesc': 'Japan Homesは注文変更、変更点、重要な意思決定をここに共有します。',
  'embed.instructions.pendingDecisions': '対応待ち {count} 件',
  'embed.instructions.pendingDecisionsDesc': '以下の項目を確認し、承認または却下してください。',

  // ── Embed: Notifications ──
  'embed.notifications.viewAll': 'すべての通知を見る',

  // ── Embed: Updates ──
  'embed.updates.noUpdates': '更新情報はまだありません',
  'embed.updates.noUpdatesDesc': 'Japan Homesはプロジェクトが進むにつれて、ここに更新情報を投稿します。',
  'embed.updates.noPhotos': '写真はまだありません。工事が始まると表示されます。',

  // ── Common Status Labels ──
  'status.open': '未対応',
  'status.inReview': '確認中',
  'status.resolved': '解決済み',
  'status.pending': '保留中',
  'status.approved': '承認済み',
  'status.declined': '却下',
  'status.acknowledged': '確認済み',
  'status.completed': '完了',
  'status.sent': '送信済み',
  'status.awaitingApproval': '承認待ち',
  'status.closed': '終了',
  'status.due': '今回支払い',
  'status.overdue': '期限超過',
  'status.upcoming': '今後',
  'status.paid': '支払済み',
  'status.confirmed': '確認済み',
  'status.awaitingReview': '確認待ち',

  // ── Common Type Labels ──
  'type.orderChange': '注文変更',
  'type.variation': '変更点',
  'type.approvalRequest': '承認が必要',
  'type.instruction': '指示',
  'type.designDecision': 'デザイン決定',
  'type.payment': '支払い',
  'type.scheduleChange': 'スケジュール変更',
  'type.changeOrder': '変更指示',
  'type.progressUpdate': '進捗更新',
  'type.question': '質問',
  'type.issueReport': '問題報告',
  'type.completion': '完了',

  // ── Common Actions ──
  'common.readMore': 'もっと見る',
  'common.showLess': '折りたたむ',
  'common.noReplies': '返信はまだありません',
  'common.loading': '読み込み中...',
  'common.today': '今日',
  'common.justNow': 'たった今',
  'common.minAgo': '{count} 分前',
  'common.hrAgo': '{count} 時間前',
  'common.dayAgo': '{count} 日前',
  'common.dueToday': '本日期限',
  'common.dueTomorrow': '明日期限',
  'common.overdue': '期限超過',

  // ── Instruction type labels ──
  'client.type.orderChange': '注文変更',
  'client.type.variation': '変更点',
  'client.type.approvalRequired': '承認が必要',
  'client.type.instruction': '指示',
  'client.type.designDecision': 'デザイン決定',
  'client.type.payment': '支払い',
  'client.type.scheduleChange': 'スケジュール変更',
  'client.type.changeOrder': '変更指示',

  // ── Instruction status labels ──
  'client.status.pending': '保留中',
  'client.status.sent': '送信済み',
  'client.status.inProgress': '進行中',
  'client.status.approved': '承認済み',
  'client.status.declined': '却下',
  'client.status.clientApproved': 'クライアント承認済み',
  'client.status.clientDeclined': 'クライアント却下',
  'client.status.acknowledged': '確認済み',
  'client.status.closed': '終了',
  'client.status.completed': '完了',
  'client.status.awaitingApproval': '承認待ち',
  'client.status.confirming': '確認待ち',

  // ── Payment status labels ──
  'client.payment.paid': '支払済み',
  'client.payment.confirmed': '確認済み',
  'client.payment.awaitingReview': '確認待ち',
  'client.payment.dueNow': '今回支払い',
  'client.payment.overdue': '期限超過',
  'client.payment.upcoming': '予定',
};

export default translations;